import { Const } from '../lib/const.cls'

export const getters = {
	//trading-tool
	[Const.GET_JURISDICTION_TAX_RESIDENCE]: (state) => { return state.jurisdiction_tax_residence_list },
	[Const.GET_SIGNAL_CENTRE]: (state) => { return state.signalCentre },
	[Const.GET_AUTO_CHARTIST]: (state) => { return state.autoChartist },
	[Const.GET_SUB_PLAN_LIST]: (state) => { return state.subPlanList },
	[Const.GET_SUB_PLAN_DETAIL]: (state) => { return state.sunPlanDetail },
	[Const.GET_CURRENT_NEWS]: (state) => { return state.currentNews },
	[Const.GET_ECONOMIC_CALENDER_DATA]: (state) => { return state.economicCalData },
	[Const.GET_VPS_LIST]: (state) => { return state.vpsList },
	[Const.GET_VPS_DETAIL]: (state) => { return state.vpsDetail },

	[Const.GET_COUPON_LIST]: (state) => { return state.couponlist },
	[Const.GET_LEVERAGE_JSON]: (state) => { return state.leverageJson },
	[Const.GET_LEVERAGE_JSON_PL_COUNTRY]: (state) => { return state.leverageJsonPLCountry },

	//user
	[Const.GET_USER_PROFILE]: (state) => { return state.userProfile },
	[Const.GET_COUNTRY_TAX_RESIDENCE_NATIONALITY]: (state) => { return state.country_tax_residence_nationality },
	[Const.GET_USER_NOTIFICATIONS]: (state) => { return state.userNotify },
	[Const.GET_EMP_STATUS]: (state) => { return state.empStatus },
	[Const.GET_AC_OPENING_REASON]: (state) => { return state.acOpeningReason },
	[Const.GET_SOURCE_OF_FUNDS]: (state) => { return state.sourceOfFunds },
	[Const.GET_NATURE_OF_TRANSACTION]: (state) => { return state.natureOfTransaction },
	[Const.GET_ORIGIN_OF_FUNDS]: (state) => { return state.originOfFunds },
	[Const.GET_GENDER_LIST]: (state) => { return state.genderList },
	[Const.GET_IS_TRADING_EXPERIENCE]: (state) => { return state.isTradingExperience },
	[Const.GET_OCCUPATION]: (state) => { return state.occupation },
	[Const.GET_EDUCATION]: (state) => { return state.education },
	[Const.GET_EMPLOYMENT]: (state) => { return state.employment },
	[Const.GET_EST_YEARLY_INCOME]: (state) => { return state.estYearlyIncome },
	[Const.GET_EST_NET_WORTH]: (state) => { return state.estNetWorth },
	[Const.GET_NET_DISPOSABLE_INCOME]: (state) => { return state.netDisposableIncome },
	[Const.GET_INVESTED_TRADING_AMOUNT]: (state) => { return state.investedTradingAmount },
	[Const.GET_TRADING_TURNOVER]: (state) => { return state.tradingTurnover },
	[Const.GET_ANT_ACCOUNT_TURNOVER]: (state) => { return state.antAccountTurnover },
	[Const.GET_COUNTRIES_LIST]: (state) => { return state.countriesList },
	[Const.GET_CITIES_LIST]: (state) => { return state.citiesList },
	[Const.GET_DOCS_LINK]: (state) => { return state.docsLink },
	[Const.GET_TIN_PASSPORT_OPTION]: (state) => { return state.CRSNUMBER },

	//trading accounts
	[Const.GET_TRADING_ACCOUNT_LIST]: (state) => { return state.tradingAccountList },
	[Const.GET_LIVE_ACCOUNT_LIST]: (state) => { return state.liveAccountList },
	[Const.GET_DEMO_ACCOUNT_LIST]: (state) => { return state.demoAccountList },
	[Const.GET_ACCOUNT_DETAILS]: (state) => { return state.accountDetails },
	[Const.GET_LAST_SELECT_TRADING_ACCOUNT]: (state) => { return state.lastSelectTradingAccount },
	[Const.GET_CURRENCY]: (state) => { return state.currency },

	//deposit
	[Const.GET_DEPOSIT_LIST]: (state) => { return state.depositList },
	[Const.GET_DEPOSIT_LIMIT]: (state) => { return state.deposit_limit },
	[Const.GET_PAYMENT_STATUS]: (state) => { return state.paymentStatus },
	[Const.GET_DEPOSIT_METHOD]: (state) => { return state.depositMethod },
	[Const.GET_DEPOSIT_BANK_LIST]: (state) => { return state.depositBankListDetail },
	[Const.GET_DEPOSIT_TYPE]: (state) => { return state.depositType },

	//withdrawal
	[Const.GET_WITHDRAWAL_LIST]: (state) => { return state.withdrawalList },
	[Const.GET_WITHDRAWAL_TYPE]: (state) => { return state.withdrawalType },
	[Const.GET_WITHDRAWAL_METHOD_RESPONSE]: (state) => { return state.withdrawalMethodResponse },
	[Const.GET_WITHDRAWAL_METHOD_RESPONSE_DEP]: (state) => { return state.withdrawalMethodResponseDep },
	[Const.GET_WITHDRAWAL_METHOD]: (state) => { return state.withdrawalMethod },
	[Const.GET_WITHDRAWAL_STATUS]: (state) => { return state.withdrawalStatus },

	//bonus
	[Const.GET_BONUS_LIST]: (state) => { return state.bonusList },
	[Const.GET_BONUS_TYPE]: (state) => { return state.bonusType },

	//support
	[Const.GET_TICKET_DATA]: (state) => { return state.ticketData },
	[Const.GET_TICKET_LIST]: (state) => { return state.ticketList },
	[Const.GET_TICKET_VIEW]: (state) => { return state.ticketView },
	[Const.GET_TICKET_REASON_LIST]: (state) => { return state.ticketReasonList },
	[Const.GET_REASON_LIST]: (state) => { return state.reasonList },

	[Const.GET_EUROPEAN_COUNTRY_LIST]: (state) => { return state.european_countries_list },

	//bank
	[Const.GET_BANK_LIST]: (state) => { return state.bankList },

	[Const.GET_DEPOSIT_LINK]: (state) => { return state.depositLink },
	[Const.GET_IMAGE_LINK_PORTFOLIO]: (state) => { return state.imageLinkPortfolio },
	[Const.GET_VIDEO_TUTORIAL]: (state) => { return state.VIDEO_TUTORIAL },
	[Const.GET_HOOPS_DATA]: (state) => { return state.hoopsData },

	//static
	[Const.GET_LEGAL_DOC_LINK]: (state) => { return state.legalDocLink },
	[Const.GET_PRIVACY_POLICY_LINK]: (state) => { return state.privacyPolicyLink },
	[Const.GET_CLIENT_AGREEMENT_LINK]: (state) => { return state.ClientAgreement },
	[Const.GET_IDEN_PROCEDURE_LINK]: (state) => { return state.IdentificationProcedure },
	[Const.GET_ORDEREXE_POLICY_LINK]: (state) => { return state.OrderExecutionPolicy },
	[Const.GET_CONFLICT_INTEREST_LINK]: (state) => { return state.ConflictofInterest },
	[Const.GET_CLIENT_CATEGORISATION_LINK]: (state) => { return state.ClientCategorisation },
	[Const.GET_INVESTOR_COMPENSATION_LINK]: (state) => { return state.InvestorCompensation }
}



// WEBPACK FOOTER //
// ./src/plugins/fxView/provider/candle-history/store-addons/getters.js